<template>
  <modal ref="modal" modal-id="modal-step" size="md"
         :show-on-mount="true">
    <template #header>
      <div class="w-100 p-3 header-success">
        <div class="modal-title text-center">
          <strong>
            {{ i18n.t(thanksMessageKey) }}
          </strong>
          <div v-if="successMessageKey" class="subtitle">
            {{ i18n.t(successMessageKey) }}
          </div>
        </div>
      </div>
    </template>

    <template #sub-heading>
      <modal-progress-bar class="w-100" :percentage="progressPercentage" />
    </template>


    <template #body>
      <slot name="body" />
      <div class="w-100 mt-4 border-top" :class="{'d-md-none': !hasNextStep}">
        <div class="footer-content pt-4 d-flex flex-column">
          <button v-if="hasNextStep" type="button" class="btn btn-light-tinted skip-step-button mt-1 mb-4 mb-md-0" @click="nextStep">
            {{ i18n.t('public.daisy_chains.skip_this_step') }}
          </button>
          <button type="button" class="close-button btn btn-link mt-1 mb-2 d-md-none" @click="closeModal()">
            {{ i18n.t('close') }}
          </button>
        </div>
      </div>
    </template>

    <template #outer-navigation>
      <modal-external-close @click="closeModal" />
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/modal'
import ModalExternalClose from '@/components/modal-external-close'
import ModalProgressBar from './modal-progress-bar'

export default {
  components: { Modal, ModalExternalClose, ModalProgressBar },

  computed: {
    ...mapState('daisyChain', ['hasNextStep', 'successMessageKey', 'thanksMessageKey', 'stepsProgress']),

    progressPercentage() {
      return this.stepsProgress * 100
    }
  },

  methods: {
    closeModal() {
      this.$refs.modal.close()
    },
    nextStep() {
      this.$store.dispatch('daisyChain/loadNextStep')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.modal-header) {
  padding: 0;
}

.modal-title {
  strong {
    font-weight: bold;
  }
}

.subtitle {
  font-size: 1rem;
}

.header-success {
  border-radius: inherit;
  background-color: #f3fef7;
}

.skip-step-button {
  text-transform: unset;
  font-size: 1rem;
  padding: 1rem;
}

.close-button {
  color: #999;
  text-decoration: underline;
  font-size: 1rem;
  font-weight: normal;
}
</style>
